export const SITE = {
  name: "Gold Time Jewelry",
  // Primary line = Katy showroom. WhatsApp number still a placeholder until the owner confirms one.
  phoneDisplay: "(346) 307-7864",
  phoneHref: "tel:+13463077864",
  // WhatsApp = Katy showroom line until a dedicated number is confirmed.
  whatsappHref: "https://wa.me/13463077864",
  domain: "mygoldtime.com",
  // Sister lead-gen site for people SELLING Swiss watches (opposite intent of this store).
  watchBuyersUrl: "https://www.webuyswisswatches.com/",
  watchBuyersName: "WeBuySwissWatches.com",
  socials: {
    instagram: "https://www.instagram.com/goldtimeofficial",
    facebook: "https://www.facebook.com/mygoldtimeofficial",
  },
  emails: {
    main: "hello@mygoldtime.com",
    katy: "katy@mygoldtime.com",
    cove: "cove@mygoldtime.com",
    killeen: "killeen@mygoldtime.com",
  },
  hours: [
    { days: "Monday – Saturday", time: "10:00 AM – 7:00 PM" },
    { days: "Sunday", time: "12:00 – 6:00 PM" },
  ],
  locations: [
    {
      name: "Katy Showroom",
      lines: ["6711 S Fry Rd STE 2", "Katy, TX 77494"],
      phone: "(346) 307-7864",
      phoneHref: "tel:+13463077864",
    },
    {
      name: "Copperas Cove Showroom",
      lines: ["2990 East US Business 190", "Copperas Cove, TX"],
      phone: "(254) 547-4653",
      phoneHref: "tel:+12545474653",
    },
    {
      name: "Killeen Showroom",
      lines: ["1101 W Stan Schlueter Loop Ste 200", "Killeen, TX 76549"],
      phone: "(254) 539-4653",
      phoneHref: "tel:+12545394653",
    },
  ].map((loc) => ({
    ...loc,
    mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`Gold Time ${loc.lines.join(", ")}`)}`,
  })),
};

export const IMAGES = {
  hero: "/assets/hero.jpg",
  buyGold: "/assets/sell-gold.jpg",
  watchLuxury: "/assets/luxury-watches.jpg",
  jewelry: "/assets/gold-jewelry.jpg",
  diamond: "/assets/diamond-jewelry.jpg",
  precision: "/assets/watchmaker.jpg",
  craft: "/assets/craftsmanship.jpg",
  sellGold: "/assets/sell-gold-appraisal.jpg",
  sellWatches: "/assets/sell-watch-appraisal.jpg",
  sellDiamonds: "/assets/sell-diamond-appraisal.jpg",
};
